import { ConfigRegistroCalifComponent } from './pages/docentes/config-registro-calif/config-registro-calif.component';
import { DataTablesModule } from 'angular-datatables';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ViewHeaderComponent } from './componentes/view-header/view-header.component';
import { ViewFooterComponent } from './componentes/view-footer/view-footer.component';
import { ViewAccesoPortalNotasComponent } from './pages/administrativos/portal-docente/view-acceso-portal-notas/view-acceso-portal-notas.component';
import { ViewConfigExclusionAsignaturaComponent } from './pages/administrativos/mantenedores/exclusion-asignaturas/view-config-exclusion-asignatura/view-config-exclusion-asignatura.component';
import { ViewPonderacionIndividualInicioComponent } from './pages/administrativos/mantenedores/ponderacion-individual/view-ponderacion-individual-inicio/view-ponderacion-individual-inicio.component';
import { ViewPonderacionIndividualCrearComponent } from './pages/administrativos/mantenedores/ponderacion-individual/view-ponderacion-individual-crear/view-ponderacion-individual-crear.component';
import { ViewPonderacionIndividualEditarComponent } from './pages/administrativos/mantenedores/ponderacion-individual/view-ponderacion-individual-editar/view-ponderacion-individual-editar.component';
import { ViewPonderacionMasivaComponent } from './pages/administrativos/mantenedores/ponderacion-masiva/view-ponderacion-masiva/view-ponderacion-masiva.component';
import { ViewConsultaEstadoSeccionComponent } from './pages/administrativos/docentes/estado-seccion/view-consulta-estado-seccion/view-consulta-estado-seccion.component';
import { ViewCalendarioProcesosInicioComponent } from './pages/administrativos/mantenedores/calendario-procesos/view-calendario-procesos-inicio/view-calendario-procesos-inicio.component';
import { ViewCalendarioProcesosCrearComponent } from './pages/administrativos/mantenedores/calendario-procesos/view-calendario-procesos-crear/view-calendario-procesos-crear.component';
import { ViewReemplazoDocenteInicioComponent } from './pages/administrativos/docentes/reemplazo-docente/view-reemplazo-docente-inicio/view-reemplazo-docente-inicio.component';
import { ViewReemplazoDocenteCrearComponent } from './pages/administrativos/docentes/reemplazo-docente/view-reemplazo-docente-crear/view-reemplazo-docente-crear.component';
import { ViewMantenedorSeccionesComponent } from './pages/administrativos/mantenedores/secciones/view-mantenedor-secciones/view-mantenedor-secciones.component';
import { ViewMantenedorMenuesRolesComponent } from './pages/administrativos/accesos/menu-rol/view-mantenedor-menues-roles/view-mantenedor-menues-roles.component';
import { ViewReporteAuditoriaComponent } from './pages/administrativos/reportes/auditoria/view-reporte-auditoria/view-reporte-auditoria.component';
import { ViewReporteEstadoSeccionesComponent } from './pages/administrativos/reportes/estado-secciones/view-reporte-estado-secciones/view-reporte-estado-secciones.component';
import { ViewReporteHistoricoCalificacionesComponent } from './pages/administrativos/reportes/historico-calificaciones/view-reporte-historico-calificaciones/view-reporte-historico-calificaciones.component';
import { ViewReporteNotasParcialesComponent } from './pages/administrativos/reportes/calificaciones-parciales/view-reporte-notas-parciales/view-reporte-notas-parciales.component';
import { ViewMantenedorUsuarioInicioComponent } from './pages/administrativos/accesos/usuarios/view-mantenedor-usuario-inicio/view-mantenedor-usuario-inicio.component';
import { ViewMantenedorUsuarioCrearComponent } from './pages/administrativos/accesos/usuarios/view-mantenedor-usuario-crear/view-mantenedor-usuario-crear.component';
import { ViewMantenedorUsuarioCrearSeleccionarComponent } from './pages/administrativos/accesos/usuarios/view-mantenedor-usuario-crear-seleccionar/view-mantenedor-usuario-crear-seleccionar.component';
import { ViewInicioComponent } from './pages/view-inicio/view-inicio.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from "ngx-spinner";
import { PopoverComponent } from './componentes/popover/popover.component';
import { ModalInfoComponent } from './componentes/modal-info/modal-info.component';
import { ViewPaginaSinAccesoComponent } from './pages/view-pagina-sin-acceso/view-pagina-sin-acceso.component';
import { LoginComponent } from './pages/login/login.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { CapitalizePipe } from './pipe/capitalize/capitalize.pipe';
import { CallbackComponent } from './pages/callback/callback.component';

import { AuthInterceptorService } from './services/auth-interceptor/auth-interceptor.service';
import { AuthGuardGuard } from './services/auth-guard/auth-guard.guard';
import { ViewMantenedorUsuarioEditarComponent } from './pages/administrativos/accesos/usuarios/view-mantenedor-usuario-editar/view-mantenedor-usuario-editar.component';
import { VisualizacionSeccionComponent } from './pages/docentes/visualizacion-seccion/visualizacion-seccion.component';
import { IngresoCalificacionesMobileComponent } from './pages/docentes/ingreso-calificaciones-mobile/ingreso-calificaciones-mobile.component';
import { SeleccionCalificacionComponent } from './pages/docentes/seleccion-calificacion/seleccion-calificacion.component';
import { IngresoCalificacionComponent } from './pages/docentes/ingreso-calificacion/ingreso-calificacion.component';
import { PortalCalificacionesComponent } from './pages/docentes/portal-calificaciones/portal-calificaciones.component';
import { FiltroAlumnosPipe } from './pipe/filtro-alumnos/filtro-alumnos.pipe';
import { ServiceErrModalComponent } from './componentes/service-err-modal/service-err-modal.component';
import { ViewReemplazoDocenteEditarComponent } from './pages/administrativos/docentes/reemplazo-docente/view-reemplazo-docente-editar/view-reemplazo-docente-editar/view-reemplazo-docente-editar.component';
import { DatePipe } from '@angular/common';
import { ViewReporteEstadoAvanceSeccionesComponent } from './pages/administrativos/docentes/estado-seccion/view-reporte-estado-avance-secciones/view-reporte-estado-avance-secciones.component';
import { ViewConfiguracionCargaCalificacionesComponent } from './pages/administrativos/mantenedores/configuracion-carga-calificaciones/view-configuracion-carga-calificaciones/view-configuracion-carga-calificaciones.component';
import { ViewReportePonderacionesIndividualesComponent } from './pages/administrativos/reportes/ponderaciones-individuales/view-reporte-ponderaciones-individuales/view-reporte-ponderaciones-individuales.component';
import { ModalPonderacionNotasPreviasComponent } from './componentes/modal-ponderacion-notas-previas/modal-ponderacion-notas-previas.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {MatCardModule} from '@angular/material/card';
import { ViewIntegracionBlackboardInicioComponent } from './pages/administrativos/integraciones/view-integracion-blackboard-inicio/view-integracion-blackboard-inicio.component';
import { ViewIntegracionBlackboardCrearComponent } from './pages/administrativos/integraciones/view-integracion-blackboard-crear/view-integracion-blackboard-crear.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlineacionBlackboardComponent } from './pages/docentes/alineacion-blackboard/alineacion-blackboard.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MondayFirstDateAdapter } from './services/utils/monday-first-date-adapter';


interface NgxSpinnerConfig {
  type?: string;
}
@NgModule({
  declarations: [
    AppComponent,
    ViewHeaderComponent,
    ViewFooterComponent,
    ViewAccesoPortalNotasComponent,
    ViewConfigExclusionAsignaturaComponent,
    ViewPonderacionIndividualInicioComponent,
    ViewPonderacionIndividualCrearComponent,
    ViewPonderacionIndividualEditarComponent,
    ViewPonderacionMasivaComponent,
    ViewConsultaEstadoSeccionComponent,
    ViewCalendarioProcesosInicioComponent,
    ViewCalendarioProcesosCrearComponent,
    ViewReemplazoDocenteInicioComponent,
    ViewReemplazoDocenteCrearComponent,
    ViewMantenedorSeccionesComponent,
    ViewMantenedorMenuesRolesComponent,
    ViewReporteAuditoriaComponent,
    ViewReporteEstadoSeccionesComponent,
    ViewReporteHistoricoCalificacionesComponent,
    ViewReporteNotasParcialesComponent,
    ViewMantenedorUsuarioInicioComponent,
    ViewMantenedorUsuarioCrearComponent,
    ViewMantenedorUsuarioCrearSeleccionarComponent,
    ViewMantenedorUsuarioEditarComponent,
    ViewInicioComponent,
    PopoverComponent,
    ModalInfoComponent,
    ViewPaginaSinAccesoComponent,
    LoginComponent,
    CapitalizePipe,
    CallbackComponent,
    ConfigRegistroCalifComponent,
    VisualizacionSeccionComponent,
    IngresoCalificacionesMobileComponent,
    SeleccionCalificacionComponent,
    IngresoCalificacionComponent,
    PortalCalificacionesComponent,
    FiltroAlumnosPipe,
    ServiceErrModalComponent,
    ViewReemplazoDocenteEditarComponent,
    ViewReporteEstadoAvanceSeccionesComponent,
    ViewConfiguracionCargaCalificacionesComponent,
    ViewReportePonderacionesIndividualesComponent,
    ModalPonderacionNotasPreviasComponent,
    ViewIntegracionBlackboardInicioComponent,
    ViewIntegracionBlackboardCrearComponent,
    AlineacionBlackboardComponent,
  ],
  imports: [
    BrowserModule,
    MatTooltipModule,
    AppRoutingModule,
    DataTablesModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatAutocompleteModule,
    MatCardModule,
    DragDropModule,
    MatFormFieldModule,
    MatSelectModule,
    MatStepperModule,
    MatIconModule,
    NgSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CL' },
    { provide: DateAdapter, useClass: MondayFirstDateAdapter, deps: [MAT_DATE_LOCALE] },
    AuthGuardGuard,
    ServiceErrModalComponent,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
